import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/components/feature/HeroSection';
import CategoryDropdown from '@/components/feature/CategoryDropdown';
import ProductShowcase from '@/components/feature/ProductShowcase';
import WhatIsSection from '@/components/feature/WhatIsSection';
import GuidesSection from '@/components/feature/GuidesSection';
import ComparisonTable from '@/components/feature/ComparisonTable';
import SafetySection from '@/components/feature/SafetySection';
import FAQSection from '@/components/feature/FAQSection';
import CTASection from '@/components/feature/CTASection';
import ReviewSection from '@/components/feature/ReviewSection';
import ShippingSection from '@/components/feature/ShippingSection';
import WarehouseSection from '@/components/feature/WarehouseSection';
import CouponSection from '@/components/feature/CouponSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-14 md:pt-16">
        <HeroSection />
        <CategoryDropdown />
        <ProductShowcase />
        <WhatIsSection />
        <ReviewSection />
        <ShippingSection />
        <WarehouseSection />
        <CouponSection />
        <GuidesSection />
        <ComparisonTable />
        <SafetySection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}